// src/components/dashboard/CapabilityGapsCard.tsx
import React from 'react';

interface CapabilityGapsCardProps {
  gaps: string[];
}

export const CapabilityGapsCard: React.FC<CapabilityGapsCardProps> = ({ gaps }) => {
  if (gaps.length === 0) {
    return (
      <div className="rounded-xl border border-brand-border p-6">
        <h2 className="text-sm font-medium text-brand-black mb-1">Capability gaps</h2>
        <p className="text-sm text-brand-gray">All capabilities active.</p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-brand-border p-6">
      <h2 className="text-sm font-medium text-brand-black mb-3">Not yet discoverable</h2>
      <div className="flex flex-wrap gap-2">
        {gaps.map((g) => (
          <span
            key={g}
            className="text-xs font-mono px-2.5 py-1 rounded-full border border-brand-border text-brand-charcoal"
          >
            {g}
          </span>
        ))}
      </div>
    </div>
  );
};